
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M22.42 11.34L20.56 9.22001L20.82 6.41001C20.87 5.91001 20.53 5.45001 20.05 5.34001L17.29 4.71001L15.85 2.28001C15.59 1.85001 15.06 1.67001 14.6 1.87001L12 3.00001L9.41002 1.89001C8.95002 1.69001 8.41002 1.87001 8.16002 2.30001L6.71002 4.72001L3.96002 5.34001C3.47002 5.45001 3.13002 5.90001 3.18002 6.41001L3.44002 9.21001L1.58002 11.34C1.25002 11.72 1.25002 12.28 1.58002 12.66L3.44002 14.78L3.18002 17.6C3.13002 18.1 3.47002 18.56 3.95002 18.67L6.71002 19.3L8.15002 21.72C8.41002 22.15 8.94002 22.33 9.41002 22.13L12 21L14.59 22.11C15.05 22.31 15.59 22.13 15.84 21.7L17.28 19.27L20.04 18.64C20.53 18.53 20.86 18.07 20.81 17.57L20.55 14.76L22.41 12.64C22.75 12.28 22.75 11.72 22.42 11.34ZM13 17H11V15H13V17ZM12 13C11.45 13 11 12.55 11 12V8.00001C11 7.45001 11.45 7.00001 12 7.00001C12.55 7.00001 13 7.45001 13 8.00001V12C13 12.55 12.55 13 12 13Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-new-releases`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNewReleases

    ```js
    <b-new-b-icon-new-releases />
    ```
</docs>


